import React, { createContext, useReducer, useContext } from 'react';
import PropTypes from 'prop-types';

import { authInitState } from './initialStates';
import authReducer from './reducers/authReducer';
const AuthStateContext = createContext(authInitState);
AuthStateContext.displayName = 'AuthContext';

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(authReducer, authInitState);
  return (
    <AuthStateContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      {children}
    </AuthStateContext.Provider>
  );
}

function useAuthState() {
  const context = useContext(AuthStateContext);
  if (context === undefined) {
    throw new Error('useAuthState must be used within a AuthProvider');
  }
  return context.state;
}

function useAuthDispatch() {
  const context = useContext(AuthStateContext);
  if (context === undefined) {
    throw new Error('useAuthDispatch must be used within a AuthProvider');
  }
  return context.dispatch;
}

AuthProvider.propTypes = {
  children: PropTypes.node
};

export { AuthProvider, useAuthState, useAuthDispatch };
